module.exports = __webpack_public_path__ + "img/17.461f3a72.jpg";